import { atom } from 'recoil';

export const showHeaderCompaniesAtom = atom({ key: 'showHeaderCompaniesAtom', default: false });
